import Box from '@mui/material/Box';
import { getLinkFromVersion } from '../helper';
import { GTCDescription } from './GTCDescription';
import GTCTitle from './GTCTitle';
import GTCVersionList from './GTCVersionList';

const styles = {
  root: {
    borderTop: '2px solid',
    borderTopColor: 'secondary.light',
    height: 'auto',
    mx: 2,
    my: 1,
    p: 2,
    width: 300,
  },
};

export interface IGTCItem {
  basePath: string;
  dataTestId?: string;
  description: string;
  name: string;
  versions: object[];
}

export function GTCItem({ basePath, dataTestId, description, name, versions }: IGTCItem) {
  const link = getLinkFromVersion(versions);
  return (
    <Box sx={styles.root}>
      <GTCTitle dataTestId={dataTestId} link={basePath.replace(':slug', link.path).replace(':version', `v${link.version}`)} title={name} />
      <GTCDescription html={description} />
      <GTCVersionList basePath={basePath} versions={versions} />
    </Box>
  );
}
